import * as React from 'react';
import { SmallImageContext } from '../../common/ContentfulImage/SmallImageContext.esm.js';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './LogosSection.module.esm.js';

var LogoList = function (_a) {
    var images = _a.images;
    return (React.createElement("ul", { className: styles.logos }, images.map(function (image, key) { return (React.createElement("li", { className: styles.logo, key: key },
        React.createElement(SmallImageContext, null,
            React.createElement(BaseNucleobaseComponent, { classes: { picture: styles.image }, source: image })))); })));
};

export { LogoList as default };
//# sourceMappingURL=LogoList.esm.js.map
